<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
    <app-input-form-field
      formControlName="problemTitle"
      [label]="'problemRecord.fields.problemTitle.label' | translate"
      [viewMode]="viewMode"
      [isRequired]="!viewMode"
      [isLabelTopPosition]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="!viewMode">
    <app-select-form-field
      formControlName="problemPriority"
      [users]="false"
      [label]="'problemRecord.fields.problemPriority.label' | translate"
      [isRequired]="true"
      [bindValue]="'value'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="problemPriorityItems"
      [viewMode]="viewMode"
    ></app-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="productFamily"
      [label]="'problemRecord.fields.productFamily.label' | translate"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [isLabelTopPosition]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('productFamily')?.value || ''
      }"
      [entry]="entry1"
      (onSelectEvent)="onSelectProductFields($event, dropdownTypeEnum.PRODUCT_GROUP)"
      (onClearEvent)="resetProductFields(dropdownTypeEnum.PRODUCT_GROUP, null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="productGroup"
      [label]="'problemRecord.fields.productGroup.label' | translate"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="productGroupItems"
      [viewMode]="viewMode"
      [isLabelTopPosition]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('productFamily')?.value || '',
        entry2: form.get('productGroup')?.value || '',
      }"
      [entry]="entry2"
      (onSelectEvent)="onSelectProductFields($event, dropdownTypeEnum.PRODUCT_SUB_GROUP)"
      (onClearEvent)="resetProductFields(dropdownTypeEnum.PRODUCT_SUB_GROUP, null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="productSubGroup"
      [label]="'problemRecord.fields.productSubGroup.label' | translate"
      [isRequired]="true"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="productSubGroupItems"
      [viewMode]="viewMode"
      [isLabelTopPosition]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('productFamily')?.value || '',
        entry2: form.get('productGroup')?.value || '',
        entry3: form.get('productSubGroup')?.value || '',
      }"
      [entry]="entry3"
      (onSelectEvent)="onSelectProductSubGroupField($event)"
      (onClearEvent)="resetProductFields('', null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="productSuite"
      [label]="'problemRecord.fields.productSuite.label' | translate"
      [viewMode]="viewMode"
      [placeholder]="''"
      [isLabelTopPosition]="viewMode"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="productCompany"
      [label]="'problemRecord.fields.productCompany.label' | translate"
      [viewMode]="viewMode"
      [placeholder]="''"
      [isLabelTopPosition]="viewMode"
      [translatable]="false"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="!viewMode">
    <app-select-form-field
      formControlName="problemStage"
      [users]="false"
      [label]="'problemRecord.fields.problemStage.label' | translate"
      [isRequired]="true"
      [bindValue]="'value'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="stageItems"
      [viewMode]="viewMode"
      [isLabelTopPosition]="viewMode"
    ></app-select-form-field>
  </div>
  <div class="col-12 col-md-6" *ngIf="viewMode">
    <!-- Blank field -->
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="productDetails"
      [label]="'problemRecord.fields.productDetails.label' | translate"
      [viewMode]="viewMode"
      [isLabelTopPosition]="viewMode"
    ></app-input-form-field>
  </div>
  <div class="col-12 col-md-12" *ngIf="viewMode">
    <hr class="page-separator" />
  </div>
  <div class="col-12 col-md-12">
    <app-rich-text-editor
      formControlName="problemDescription"
      [label]="'problemRecord.fields.problemDescription.label' | translate"
      [isRequired]="true"
      [readonly]="viewMode"
    >
    </app-rich-text-editor>
  </div>
  <div class="col-12 col-md-12">
    <app-upload-attachments (attachmentsChange)="onFileUpload($event)" [isRequired]="false"
      [label]="'problemRecord.fields.attachments.label' | translate"
      [readonly]="viewMode" [uploadedFiles]="uploadedFiles"
      [caseId]="caseId" [caseType]="caseType"
      [touched]="attachmentsTouched"
      [disabled]="form.disabled"
    ></app-upload-attachments>
  </div>
  <div class="col-12 col-md-12" *ngIf="viewMode">
    <hr class="page-separator" />
  </div>
  <div class="col-12 col-md-6">
    <app-textarea-form-field
      formControlName="containmentSummary"
      [label]="'problemRecord.fields.containmentSummary.label' | translate"
      [viewMode]="viewMode"
      [isLabelTopPosition]="viewMode"
    ></app-textarea-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-textarea-form-field
      formControlName="resolutionSummary"
      [label]="'problemRecord.fields.resolutionSummary.label' | translate"
      [viewMode]="viewMode"
      [isLabelTopPosition]="viewMode"
    ></app-textarea-form-field>
  </div>
</div>
